import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getGeneros } from 'services/servicioGet';
import { TipoGenerico } from 'utils/models/types';

interface GenerosState {
  generos: TipoGenerico[];
  loadingGeneros: boolean;
  errorGeneros: string | null;
}

// Estado inicial del slice
const initialState: GenerosState = {
  generos: [],
  loadingGeneros: false,
  errorGeneros: null,
};

// Thunk para obtener los géneros
export const fetchGeneros = createAsyncThunk<TipoGenerico[], void, { rejectValue: string }>(
  'fetchGeneros',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getGeneros();
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de géneros
const generosSlice = createSlice({
  name: 'generos',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchGeneros.pending, state => {
        state.loadingGeneros = true;
        state.errorGeneros = null;
      })
      .addCase(fetchGeneros.fulfilled, (state, action) => {
        state.generos = action.payload;
        state.loadingGeneros = false;
      })
      .addCase(fetchGeneros.rejected, (state, action) => {
        state.loadingGeneros = false;
        state.errorGeneros = action.payload as string;
      });
  },
});

export default generosSlice.reducer;
